import { ClientType } from '@/modules/shared/schemas/ClientType'

import { ReleaseNotesRepository } from '../domain/repositories/ReleaseNotesRepository'
import { ReleaseNotesDatasource } from './datasources/ReleaseNotesDatasource'

export function releaseNotesRepositoryAdapter(
  releaseNotesDatasource: ReleaseNotesDatasource
): ReleaseNotesRepository {
  return {
    async getReleaseNotes({
      clientType,
      versionMajorNumber,
      versionMinorNumber
    }: {
      clientType: ClientType
      versionMajorNumber: number
      versionMinorNumber: number
    }) {
      return await releaseNotesDatasource.getReleaseNotes({
        clientType,
        versionMajorNumber,
        versionMinorNumber
      })
    }
  }
}
